import React, { FC, useContext } from 'react';

import { ColoredClosableHeader, SidebarContainer, StyledContainer } from '../../../containers';
import { DynamicComponentsContext }                                 from '../../../contexts';
import { ObjectiveDetails, ObjectiveDetailsProps }                  from './details/ObjectiveDetails';
import { SemanticUIColor, Size, SystemEvent, Uuid }                 from '../../../../types';
import { runIfFunction }                                            from '../../../../util';
import { useFeatureFlags }                                          from '../../../../hooks';
import { TagCloudProps }                                            from '../../../components/tag/TagCloud';

interface ObjectiveDetailsLinkProps extends ObjectiveDetailsProps {
	id: Uuid,
	content: React.ReactNode,
	onClick?: ( e: SystemEvent, objectiveId: Uuid ) => void,
	onTagClick?: TagCloudProps['onClick']
}

const defaultProps: ObjectiveDetailsLinkProps = {
	id:                     null,
	content:                null,
	projectDetails:         false,
	categoryActivitiesOnly: false,
	onClick:                null,
	onTagClick:             null,
}

const ObjectiveDetailsLink: FC<ObjectiveDetailsLinkProps> = ( _props ) => {
	
	let { sidebar: [ , sidebarActions ] } = useContext( DynamicComponentsContext ),
	    featureFlags                      = useFeatureFlags();
	
	let { id, content, onClick, onTagClick, ...props } = _props;
	
	let handleShowObjectiveDetails = ( e: SystemEvent, objectiveId: Uuid ) => {
		
		runIfFunction( onClick, e, objectiveId );
		
		sidebarActions.show( (
			
			<SidebarContainer light padded={ false } cellRows={ `auto 1fr` }>
				
				<ColoredClosableHeader
					padding={ Size.MD }
					color={ SemanticUIColor.PURPLE }
					title={ 'Project Objective Details' }
					onClose={ () => sidebarActions.toggle( false ) }
				/>
				
				<ObjectiveDetails
					id={ objectiveId }
					projectDetails={ false }
					categoryActivitiesOnly={ false }
					showTags={ props.projectDetails && featureFlags.enableProjectActivityMetatagViewsAndTools }
					onTagClick={ ( props.projectDetails && featureFlags.enableProjectActivityMetatagViewsAndTools ) ? onTagClick : null }
					{ ...props }
				/>
			
			</SidebarContainer>
		), {
			width:     'very wide',
			dimmed:    true,
			onVisible: () => {},
			onHidden:  () => {},
		} );
	}
	
	return (
		
		<a className={ 'text--no-wrap' } onClick={ ( e ) => handleShowObjectiveDetails( e, id ) }>{ content }</a>
	);
};

ObjectiveDetailsLink.defaultProps = defaultProps;

export { ObjectiveDetailsLink }
